import React, { useState, useEffect } from 'react';
import { XGrid } from '@material-ui/x-grid';
import QuickSearch from '../QuickSearch';
import { searchPeople } from 'reducers/SearchReducer';

let lastSearchTerm = '';

function MergePersonTargetDialog(props) {
  const { columns, setSourceID, targetID, showTargetPerson = false } = props;
  const [rawRows, setRawRows] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [ViewDeleted] = useState(false);
  const [targetPerson, setTargetPerson] = useState(null);

  useEffect(() => {
    const r = props.rows.filter((x) => x.id !== targetID && !x.IsDeleted);
    setTargetPerson(props.rows.find((x) => x.id === targetID));
    setRawRows(r);
  }, []);

  const search = async (text = lastSearchTerm) => {
    lastSearchTerm = text;
    if (!text || text.length < 3) return;
    setLoaded(false);
    searchPeople(lastSearchTerm, ViewDeleted)
      .then((result) => {
        const r = result.filter((x) => x.ptsPersonID !== targetPerson.ptsPersonID && !x.IsDeleted);
        setRawRows(r);
      })
      .finally(() => setLoaded(true));
  };

  const processedRows = React.useMemo(() => {
    const newRows = rawRows.map((row) => ({
      ...row,
      id: row.ptsPersonID + ' ' + row.PersonID,
    }));

    const targetRows =
      showTargetPerson && targetPerson
        ? [{ ...targetPerson, id: targetPerson.ptsPersonID + ' ' + targetPerson.PersonID }]
        : [];
    const merged = [...targetRows, ...selectedRowsData, ...newRows];

    return Array.from(new Map(merged.map((r) => [r.id, r])).values());
  }, [rawRows, selectedRowsData, showTargetPerson, targetPerson]);

  const normalizeSelection = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.selectionModel)) return payload.selectionModel;
    return [];
  };

  const handleSelectChange = (payload) => {
    const sel = normalizeSelection(payload);
    setSelectedIDs(sel);
    const selected = processedRows.filter(
      (r) => sel.includes(r.id) && r.ptsPersonID !== targetPerson?.ptsPersonID
    );
    setSelectedRowsData(selected);
    const sourceIds = selected.map((r) => r.ptsPersonID);
    setSourceID(sourceIds);
    props.setRows((prevRows) => {
      const existingIdSet = new Set(prevRows.map((r) => r.ptsPersonID));
      const missingRows = selected.filter((s) => !existingIdSet.has(s.ptsPersonID));
      return [...prevRows, ...missingRows];
    });
  };

  return (
    <>
      <QuickSearch search={search} loaded={loaded} />

      <div style={{ height: 500 }}>
        <XGrid
          columns={columns}
          rows={processedRows}
          checkboxSelection
          isRowSelectable={(params) => params.row.ptsPersonID !== targetPerson?.ptsPersonID}
          selectionModel={selectedIDs}
          onSelectionModelChange={handleSelectChange}
        />
      </div>
    </>
  );
}

export default MergePersonTargetDialog;
